import styled from 'styled-components';

export const StyledBroadsiderMenu = styled.div`
  z-index: 99;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  transform-origin: 0 0;
  transform: scale(var(--app-scale));

  .broadsider-menu-contents {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: stretch;
    width: 100%;
    gap: 4px;
  }

  .broadsider-menu-border {
    border: solid ${({ theme }) => theme.frameWidth} white;
    border-right: none;
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ $itemsCount }) => 'calc(3rem * ' + $itemsCount + ' + 64px + 12px)'};

    @media (max-height: 550px) {
      height: ${({ $itemsCount }) => 'calc(2.25rem * ' + $itemsCount + ' + 48px + 12px)'};
    }
  }

  .broadsider-menu-button-holder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
  }

  .broadsider-menu-separator-vertical {
    width: 8px;
    min-width: 8px;
    background: ${({ theme }) => theme.selection };
  }

  .broadsider-menu-separator-vertical-short {
    width: 8px;
    height: 3rem;
    min-width: 8px;
    transition: linear .2s;
    background: ${({ theme }) => theme.selection };

    @media (max-height: 550px) {
      height: 2.25rem;
    }
  }

  .broadsider-menu-separator-vertical-spacer {
    width: 8px;
    height: 4px;
    min-width: 8px;
    background: ${({ theme }) => theme.selection };
  }

  .broadsider-menu-separator-vertical-wide {
    width: 16px;
    min-width: 16px;
  }

  .broadsider-menu-info-holder {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    width: 100%;
  }

  .broadsider-menu-separator-horizontal {
    height: 8px;
    width: 100%;
    background: ${({ theme }) => theme.selection };
  }

  .broadsider-menu-title {
    font-family: "NeueMachina";
    margin: 8px;
    margin-top: 0;
    font-size: 2em;
    font-weight: 700;
    text-transform: uppercase;
  }

  .broadsider-menu-description {
    margin: 8px;
    font-size: 1em;
    margin-bottom: 0;
  }

  .broadsider-menu-option {
    width: 3rem;
    height: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.625rem;
    background: white;
    transition: linear .2s;
    img {
      transition: linear .2s;
    }
    &:hover {
      cursor: pointer;
    }
    @media (max-height: 550px) {
      width: 2.25rem;
      height: 2.25rem;
      padding: 0.375rem;
    }
  }

  .broadsider-menu-option-selected {
    background: ${({ theme }) => theme.selection };
    &:hover {
      background: ${({ theme }) => theme.selection };
    }
  }

  .broadsider-menu-option-icon {
    width: 100%;
    height: 100%;
  }

  .broadsider-menu-info {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: stretch;
  }

  .broadsider-menu-list-item {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    height: 3rem;
    gap: 4px;
    &:hover {
      cursor: pointer;
    }
    @media (max-height: 550px) {
      height: 2.25rem;
    }
  }

  .broadsider-menu-list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    background: ${({ theme }) => theme.backgroundMenu};
  }

  .broadsider-menu-list-item-title {
    font-family: "NeueMachina";
    font-size: 1.5rem;
    line-height: 1em;
    font-weight: 700;
    text-transform: uppercase;
    opacity: 0.4;

    @media (max-height: 550px) {
      font-size: 1rem;
    }
  }

  .broadsider-menu-list-item-title-selected {
    opacity: 1;
  }

  .broadsider-menu-list-holder {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: stretch;
  }
`;
